import { apiGet, apiPost } from './client.js';
import type { SuggestCatalog } from '@fixflow/shared-types';

export function getCompatibilityCatalog() {
  return apiGet<SuggestCatalog>('/api/v1/devices/compatibility-catalog').then((response) => response.data);
}

export function createModelAlias(body: { modelId: string; alias: string }) {
  return apiPost<{ id: string; alias: string }>('/api/v1/devices/model-aliases', body).then(
    (response) => response.data,
  );
}

export type DeviceCompatibilityRow = {
  id: string;
  name: string;
  category: string;
  autoSuggested: boolean;
  existingModels: Array<{ modelId: string; modelName: string; makeName?: string; autoSuggested?: boolean }>;
  suggestions: Array<{
    modelId: string;
    modelName: string;
    makeId: string;
    makeName: string;
    confidence: 'high' | 'medium' | 'low';
    matchedText: string;
  }>;
};

export function listDeviceCompatibility(params: {
  mode: 'missing' | 'additional';
  confidence: 'high' | 'medium' | 'low' | 'any';
  suggestion: 'has' | 'none' | 'any';
  makeId?: string;
  category?: string;
  page: number;
}) {
  const query = new URLSearchParams({
    mode: params.mode,
    confidence: params.confidence,
    suggestion: params.suggestion,
    page: String(params.page),
    pageSize: '40',
  });
  if (params.makeId) query.set('makeId', params.makeId);
  if (params.category) query.set('category', params.category);
  return apiGet<DeviceCompatibilityRow[]>(`/api/v1/data-cleanup/device-compatibility?${query}`).then(
    (response) => response,
  );
}

export function applyDeviceCompatibility(body: {
  mode: 'missing' | 'additional';
  items: Array<{ itemId: string; modelIds: string[] }>;
}) {
  return apiPost<{ batchId: string | null; updated: number }>(
    '/api/v1/data-cleanup/device-compatibility/apply',
    body,
  ).then((response) => response.data);
}

export function listDeviceCompatibilityBatches() {
  return apiGet<
    Array<{ id: string; ticketCount: number; reason: string | null; performedAt: string; reversedAt: string | null }>
  >('/api/v1/data-cleanup/device-compatibility/batches').then((response) => response.data);
}

export function undoDeviceCompatibility(id: string) {
  return apiPost(`/api/v1/data-cleanup/device-compatibility/batches/${id}/undo`, {});
}
